import { useEffect } from "react";

/**
 * Injects a <link rel="preload" as="image"> for the given URL so the
 * browser starts fetching it while parsing the document, instead of
 * waiting for React to render the actual <img> tag. Meant for the one
 * LCP-critical image per page (a playlist/album/artist hero cover) —
 * pair with <CoverImg priority /> on that same image.
 */
export function usePreloadImage(url: string | undefined | null) {
  useEffect(() => {
    if (!url) return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = url;
    document.head.appendChild(link);
    return () => { link.remove(); };
  }, [url]);
}
